define('app/views/newsletter_view',['app/setup', 'app/views/base_view'], function(takhfifan, baseView) {

  takhfifan.NewsletterView = takhfifan.BaseView.extend({

    setCity: function(e) {
      var $target = $(e.target);
      var $li = $target.hasClass('li') ? $target : $target.closest('li');

      this.$('input[name=city]').val($li.data('cityId'));
      this.$('input[name=city]').val($li.data('cityId'));
      this.$('label.city-val').text($li.text());
    },

    submit: function(e) {
      e.preventDefault();
      this.model.set(
        takhfifan.Helper.serializeToObject(this)
      );
      this.model.validate();
      if (this.model.isValid()) {
        this.model.submit(this.$el.data('subscribe'));
        if($('.main-deal.finish').length){
          this.$el.removeClass('error-ex');
        }
      } else {
        if($('.main-deal.finish').length){
          this.$el.addClass('error-ex');
        }
        if(this.$('.alert-error').length || this.$('.tkh-error').length){
          this.$('.alert-error').slideDown();
        }
        else{
          this.$('form').append('<span class="icon-warning"></span>');
        }
      }
      return false;
    }

  });
});

